let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bPvEf")).then(() => parcelRequire('bAn7e'));